import React, { useContext } from 'react';
import RequestNavigationContext from 'contexts/request_navigation/context';

export const useRequestNavigation = () => {
  return useContext(RequestNavigationContext);
};
